<!--directiva: shared.tenant.image.html!-->
<img *ngIf="imageUri" [src]="imageUri" [ngStyle]="style" />